import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { AgentSummary } from '../../types/agent.js';
import { getAvatarUrl } from '../../services/agent-api.js';

@customElement('cp-agent-list')
export class CpAgentList extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) agents: AgentSummary[] = [];
  @property({ type: Number }) selectedId: number | null = null;

  private _handleAgentClick(agentId: number): void {
    this.dispatchEvent(new CustomEvent('agent-selected', {
      detail: { agentId },
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    if (this.agents.length === 0) {
      return html`
        <div class="cp-agent-list__empty">
          <p class="cp-agent-list__empty-text">Keine Agenten vorhanden.</p>
        </div>
      `;
    }

    return html`
      <div class="cp-agent-list">
        <div class="cp-agent-list__grid">
          ${this.agents.map(agent => this._renderCard(agent))}
        </div>
      </div>
    `;
  }

  private _renderCard(agent: AgentSummary) {
    const isSelected = this.selectedId === agent.id;

    return html`
      <div
        class="cp-agent-card ${isSelected ? 'cp-agent-card--selected' : ''}"
        @click=${() => this._handleAgentClick(agent.id)}
        role="button"
        tabindex="0"
        @keydown=${(e: KeyboardEvent) => e.key === 'Enter' && this._handleAgentClick(agent.id)}
      >
        ${agent.has_avatar
          ? html`<img class="cp-agent-card__avatar" src="${getAvatarUrl(agent.id)}" alt="${agent.name}" />`
          : html`
            <div class="cp-agent-card__avatar cp-agent-card__avatar--initials" style="background-color: ${agent.color || 'var(--color-bg-tertiary)'}">
              ${agent.name.charAt(0).toUpperCase()}
            </div>
          `
        }
        <div class="cp-agent-card__info">
          <span class="cp-agent-card__name">${agent.name}</span>
          <span class="cp-agent-card__meta">
            ${agent.is_main ? 'Haupt-Agent' : agent.personality_type || 'Agent'}
          </span>
        </div>
        ${agent.is_main ? html`
          <span class="cp-agent-card__badge">Main</span>
        ` : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-agent-list': CpAgentList;
  }
}
